import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
//import { TelemetryService } from '@infosys-it/angular-telemetry-sdk';
import { INTERACTEVENTS, IMPRESSIONEVENTS } from 'app/shared/constants';
import { Appconstants } from '../../../shared/app-constants';
import { InvestorService } from '../investor.service'
import {environment} from '../../../../environments/environment.prod';

@Component({
  selector: 'app-taxform-non-residential',
  templateUrl: './taxform-non-residential.component.html',
  styleUrls: ['./taxform-non-residential.component.css']
})
export class TaxformNonResidentialComponent implements OnInit {
  // add private telemetryService:TelemetryService
  //constructor(private investorService: InvestorService,private telemetryService:TelemetryService) { }
  constructor(private investorService: InvestorService) { }
  @Input() formName: string;
  @Output() onSubmit = new EventEmitter();
  @Output() pageName = new EventEmitter();
  @Output() scrollOnLoad = new EventEmitter();
  strVerifyResponse: object;
  strErrorMessage: string = "";
  strSuccessMessage: string = "";
  document: { documentType: string, documentContent: string, documentName: string } = {
    documentType: "", documentContent: "", documentName: ""
  };
  fileByte: string;
  invDocTypeFlag: boolean;
  disableSubmit: boolean = true;
  fileValidFlag: boolean;
  pageLoad: boolean = false;
  decCheck:boolean=false;
  downloadTempLink:string;
  reloadComponent: boolean = true;
  @Input() cycleFlag:boolean;
  @Input() selYear:string;
  @Input() cycleName:string;
  @Input() windowFlag:boolean;
  enableSubmitFlag:boolean=false;
  blnShowLoad: boolean = true;

  ngOnInit() {
    if(this.windowFlag==false && this.enableSubmitFlag==true){
      this.windowFlag=true;
    }
    console.log("formName", this.formName);
    // if (this.formName != 'otherform') {
    //   this.document.documentType = this.formName;
    // }
    // this.document.documentType = this.formName;
    // // add telemetry on page load

    if(environment.telemetryFlg){
    let impressionEventData = {
      type: IMPRESSIONEVENTS.FORM,
      pageid: Appconstants.taxFormsNonResidentialPageId,
      uri: window.location.href
    };
   // this.telemetryService.impression(impressionEventData);
  }
  
  
  }


  ngOnChanges(changes: SimpleChanges) {
    if(this.windowFlag==false && this.enableSubmitFlag==true){
      this.windowFlag=true;
    }
    for (let property in changes) {
      if (property === 'formName') {
        console.log('Previous:', changes[property].previousValue);
        console.log('Current:', changes[property].currentValue);
      }
    }  
    this.formName = changes['formName'].currentValue;
    if(changes['formName'].currentValue!='otherform'&&changes['formName'].currentValue!='TRC'&&changes['formName'].currentValue!='LTDC' ){
      this.generateDownloadLink();
    }
    if (this.formName != 'otherform') {
          this.document.documentType = this.formName;
    }
    else{
      this.document.documentType = "others";
    }
    this.scrollOnLoad.emit(true);
    this.consentFormChange();
    this.document.documentName = '';
    this.document.documentContent = '';
    this.reloadComponent= true;
    if(changes['formName'].previousValue!=null){
      (<HTMLInputElement>document.getElementById('NRDocupload'+ changes['formName'].previousValue)).value = "";
    }
    console.log("onChange",this.formName,this.document.documentType);
    this.investorService.getAllDocByType(this.document.documentType,this.selYear,this.cycleName).subscribe(data=>{
      if(data['enable_submit'].toLowerCase()=="y"){
        this.enableSubmitFlag=true;
      }
      //this.blnShowLoad = false;
    },
    err=>{
      console.log("err",err);
      //this.blnShowLoad = false;
    })
    console.log("boolean show load", this.blnShowLoad);
    console.log("window flag",this.windowFlag);
    console.log("enable submit flag",this.enableSubmitFlag);
  }
 

  generateDownloadLink(){
    this.downloadTempLink = "assets/Templates/";
    console.log(this.formName);
    let docName;
    if(this.formName=="No PE declaration"){
      this.formName="No PE declaration";
    docName= "No PE declaration";
    }
    else{
      let names = this.formName.split(' ');
    docName = names.join('-');
    docName= docName.replace('.','');
    }
    this.downloadTempLink = this.downloadTempLink + docName + '.pdf'
    console.log("download",this.downloadTempLink);
    
    // return this.downloadTempLink; 
  }

  consentFormChange(){
    this.decCheck=false;
    this.disableSubmit = true;
    this.strErrorMessage="";
   
   
  }

  convertFileToByte(file: File) {
    var fileReader: FileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onloadend = (e) => {
      this.fileByte = fileReader.result as string;
      this.fileByte = this.fileByte.split(',')[1];
      this.document.documentContent = this.fileByte;
      this.document.documentName = file.name;
      console.log("totalfiles", this.fileByte);
    };
  }

   validateType(type,name) {
    // let accept = ['application/msword', 'application/vnd.ms-excel', 'application/vnd.ms-powerpoint',
    //   'text/plain',' application/pdf', 'image/*'];
    // .xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf
  let re =/(\.pdf)$/
    if( type.match('image/*')){

      return true;
    }
    else if(re.exec(name)){
      return true;
    }
    else {
      return false;
    }

  }

  attachFile(target) {
    console.log("target", target['files']);
    if(target['files'].length>0){
        if (this.validateType(target['files'][0]['type'],target['files'][0]['name'])) {
          this.convertFileToByte(target['files'][0]);
          this.fileValidFlag = true;
        }
        else {
          console.log("invalid file");
          this.fileValidFlag = false;
          this.document['documentContent'] = '';
          this.document['documentName'] = '';
        }
    }
  }

  checkConsent(event){
    if(event.target.checked){
      this.decCheck=true;
       this.disableSubmit = false;
    }
    else{
      this.decCheck=false;
      this.disableSubmit = true;
      
    }
  }

  fnTakeAction(){
    console.log("in submit");
    console.log(this.document);
    if(this.document.documentType == ''|| this.document.documentType==null){
      this.invDocTypeFlag =true;
      return;
    }
    if(this.document.documentName == '' || this.document.documentName == null){
      this.strErrorMessage = "Please attach the document";
      return;
    }
    this.pageLoad = true;
    this.investorService.postFormDocument(this.document).subscribe(data => {
      this.strVerifyResponse= data as object;
      console.log("output",  this.strVerifyResponse);
      if (this.strVerifyResponse['code'] == "1") {
          this.reloadComponent = false;
          if(environment.telemetryFlg){
          let telemetryEventData = {
            type: INTERACTEVENTS.CLICK,
            id: "Docupload"+" " +Appconstants.submit + " " + Appconstants.success,
            pageid: Appconstants.taxFormsNonResidentialPageId
          }
        //  this.telemetryService.interact(telemetryEventData);
        }
      // this.strSuccessMessage = "Thanks for providing the details the same is under processing.";
        this.strErrorMessage = '';
        this.pageLoad = false;
        this.pageName.emit('NONRESIDENT');
        setTimeout(() => {
          //this.strSuccessMessage="";
          this.reloadComponent = true;
        }, 100);

        this.resetAfterSubmit();
        this.reset();
      }
      else{
        this.strErrorMessage=this.strVerifyResponse['message'];
        this.pageLoad = false;
            if(environment.telemetryFlg){
              let telemetryEventData = {
                type: INTERACTEVENTS.CLICK,
                id: Appconstants.submit + " " + Appconstants.error +" "+ this.strErrorMessage ,
                pageid: Appconstants.taxFormsNonResidentialPageId
              }
            // this.telemetryService.interact(telemetryEventData);
          }
          setTimeout(() => {
            this.strErrorMessage="";
          }, 3000);
       
      }
    },err=>{
      console.log(err);
      this.strErrorMessage="Some Error Occured, Please try later.";
      this.pageLoad = false;
          if(environment.telemetryFlg){
          let telemetryEventData = {
            type: INTERACTEVENTS.CLICK,
            id: Appconstants.submit + " " + Appconstants.failure +" "+ err ,
            pageid: Appconstants.taxFormsNonResidentialPageId
          }
      //    this.telemetryService.interact(telemetryEventData);
      }
      setTimeout(() => {
        this.strErrorMessage="";
      }, 3000);
    
    });
  }

  reset() {
    this.document['documentContent'] = '';
    this.document['documentName'] = '';
    (<HTMLInputElement>document.getElementById('NRDocupload'+this.formName)).value = "";
    console.log(this.document);
    
  }

  checkDisableSubmit(){
    if(this.disableSubmit==false && this.fileValidFlag == true){
      return false;
    }
    else{
      return true;
    }
  }

  DownloadTemplate(){

    
  }

  resetAfterSubmit(){
    this.decCheck = false;
    this.fileValidFlag = null;
    this.disableSubmit = true;
  }


}
